import React,{useState, useEffect} from 'react';

import ScheduleHeader from './ScheduleHeader';
import ScheduleTable from './ScheduleTable';
import ScheduleBodyHeader from './ScheduleBodyHeader';
import ScheduleCardHeader from './ScheduleCardHeader';
import ScheduleRightSidebar from './ScheduleRightSidebar';
import { Link } from 'react-router-dom';

export default function ScheduleBody(param) {

    const [type, setType] = useState("WEEK");
    const [createType, setCreateType] = useState("");
    const [programId, setProgramId] = useState("");
    const [projectId, setProjectId] = useState("");
    // ScheduleRightSiderbar
    const [contentCheck, setContentCheck] = useState("");
    const [createClear, setCreateClear] = useState(true);
    const [scheduleId, setScheduleId] = useState("");
    const [sideCheck, setSideCheck] = useState(false);
    const [count, setCount] = useState(1);
    // css
    const [wrapper, setWrapper] = useState("content-wrapper");

    function callbackType(type) {
        setType(type)
    }

    function callbackProgramId(id) {
        setProgramId(id);
    }

    function callbackProjectId(id) {
        setProjectId(id);
    }

    // 스케쥴 우측화면 나오게 하기위해서
    function wrapperCheck(check) {
        setSideCheck(check);
        if( check === true) {
            if(param.sideCheck === false) {
                // 사이드 텝 닫고 토글 연경우
                // setWrapper("content-wrapper sidetoggled"); 
                setWrapper("content-wrapper sidetoggled side");
            } else {
                //토글만 연 경우
                setWrapper("content-wrapper toggled"); 
            }
        } else {
            if(param.sideCheck === false) {
                setWrapper("content-wrapper");
            } else {
                setWrapper("content-wrapper");
            }
            
        }
        
    }
    // function wrapperChecktest() {
    //     console.log("ddddd");
    //     console.log(wrapper);
    //     if( wrapper == "content-wrapper") {
    //         console.log("change");
    //         setWrapper("content-wrapper toggled");    
    //     } else {
    //         setWrapper("content-wrapper");
    //     }
        
    // }
    
    function contentCheckButton(check) {
        setScheduleId("");
        setContentCheck(check);
        setCreateClear(!createClear);
        wrapperCheck(true);
        setCreateType(type);
    }

    function callbackScheduleId(id) {
        setScheduleId(id);
    }

    useEffect(() => {
    }, [programId, projectId])
    useEffect(() => {
        setProjectId(param.projectId);
    }, [param.projectId])

    useEffect(() => {
        if(param.type !== undefined) {
            setType(param.type);
        }
    }, [param.type])

    useEffect(() => {
        if(count !== 1) {
            wrapperCheck(sideCheck);
        } else {
            setCount(2);
        }
    }, [param.sideCheck])

    return(
        <div className={wrapper} id="wrapper">
            {/* contentCheck => message or content 확인을 위해서*/}
            <ScheduleRightSidebar sideCheck={param.sideCheck} clear={createClear} contentCheck={contentCheck} type={createType} programId={programId} projectId={projectId} scheduleId={scheduleId} callbackWrapperCheck={wrapperCheck}/>
            {/* <button className="btn btn-primary float-right" onClick={wrapperChecktest}>Toggle Menu</button> */}
            <ScheduleHeader/>
            <section className="content">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <ScheduleCardHeader type={type} programId={programId} projectId={projectId} callbackContentCheckButton={contentCheckButton} callbackWrapperCheck={wrapperCheck}></ScheduleCardHeader>
                            <div className="card-body">
                                <ScheduleBodyHeader type={type} projectId={param.projectId} programId={param.programId} callbackType={callbackType} callbackProjectId={callbackProjectId} callbackProgramId={callbackProgramId}></ScheduleBodyHeader>
                                <ScheduleTable type={type} projectId={projectId} programId={programId} callbackScheduleId={callbackScheduleId} callbackWrapperCheck={wrapperCheck}></ScheduleTable>
                            </div>
                        </div>
                        {/* {
                            programId !== "" &&
                                <div className="button-wrapper mb-5 col-12" >
                                    <div className="float-right">
                                        <ul className="nav nav-pills">
                                            <button type="button" className="btn btn-primary">
                                                <li className="nav-item dropdown">
                                                    <i className="fas fa-plus " data-toggle="dropdown">새 스케줄 등록</i>
                                                    <div className="dropdown-menu dropdown-menu-create-bottom-right">
                                                        <a className="ml-2" onClick={() => contentCheckButton("message")} data-toggle="tooltip" title="새 콘텐츠 등록" > 메시지 등록</a>
                                                            <div className="dropdown-divider"></div>
                                                        <a className="ml-2" onClick={() => contentCheckButton("content")} data-toggle="tooltip" title="새 콘텐츠 등록" > 컨텐츠 등록</a>
                                                    </div>
                                                </li>
                                            </button>
                                        </ul>
                                    </div>
                                </div>
                        } */}
                    </div>
                
                </div>
            </section>
        </div>
    );
}